<template>
  <el-container style="height: auto;padding-top:1px" class="rule auto1200">
    <el-aside width="220px" style="overflow: hidden">
      <el-menu v-if="menus.length" default-active="1" style="background: none">
        <el-submenu v-for="(toplevel, tindex) in menus" :key="toplevel.id" :index="tindex + ''">
          <template slot="title">
            <span>{{ toplevel.name }}</span>
          </template>
          <el-submenu
            v-for="(middleLevel, mindex) in toplevel.subCategories"
            :key="middleLevel.id"
            :index="tindex + '-' + mindex"
          >
            <template slot="title">{{ middleLevel.name }}</template>
            <el-menu-item
              v-for="(bottomLevel, bindex) in middleLevel.subCategories"
              :key="bottomLevel.id"
              :index="tindex + '-' + mindex + '-' + bindex"
              @click="getDetailInfo(bottomLevel.id)"
            >
              {{ bottomLevel.name }}
            </el-menu-item>
          </el-submenu>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main>
      <div class="rule-content">
        <span class="f12">各品类需要准备的资质材料略有不同，请详阅</span>
        <table>
          <colgroup>
            <col width="40%">
            <col width="60%">
          </colgroup>
          <tr>
            <th>企业资质列表</th>
            <th>
              详情
              <span class="tip">(复印件请加盖开店公司公章)</span>
            </th>
          </tr>
          <tr v-for="(row, index) in companyinfo" :key="index" :class="{'stripe': index % 2 === 1}">
            <td>{{ index + 1 }} {{ row.name }}</td>
            <td v-if="row.download">
              <a
                href="javascript:void(0)"
                class="download-text"
                @click="downloadFile(row.url, row.desc)"
              >
                点击下载: {{ row.desc }}
              </a>
            </td>
            <td v-else>{{ row.desc }}</td>
          </tr>
        </table>
        <table>
          <colgroup>
            <col width="40%">
            <col width="60%">
          </colgroup>
          <tr>
            <th>品牌资质列表</th>
            <th>
              详情
              <span class="tip">(复印件请加盖开店公司公章)</span>
            </th>
          </tr>
          <tr v-for="(row, index) in brandinfo" :key="index" :class="{'stripe': index % 2 === 1}">
            <td>{{ index + 1 }} {{ row.name }}</td>
            <td>{{ row.desc }}</td>
          </tr>
        </table>
        <table v-if="categoryinfo.length">
          <colgroup>
            <col width="40%">
            <col width="60%">
          </colgroup>
          <tr>
            <th>类目资质列表</th>
            <th>
              详情
              <span class="tip">(复印件请加盖开店公司公章)</span>
            </th>
          </tr>
          <tr v-for="(row, index) in categoryinfo" :key="index" :class="{'stripe': index % 2 === 1}">
            <td>{{ index + 1 }} {{ row.name }}</td>
            <td>{{ row.desc }}</td>
          </tr>
        </table>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import { getCategory, getCategoryQualification } from '@/api/merchant'
import { processMixin } from '../common/mixin'

export default {
  name: 'Rule',
  mixins: [processMixin],
  data: function () {
    return {
      menus: [],
      companyinfo: [
        {
          name: '企业营业执照扫描件',
          desc: '需确保未在企业经营异常名录中且所售商品在营业执照经营范围内'
        },
        {
          name: '银行开户许可证扫描件',
          desc: ''
        },
        {
          name: '法人身份证正反面扫描件',
          desc: ''
        },
        {
          name: '联系人企业授权书',
          desc: '企业授权书模板.docx',
          download: true,
          url: `https://cdn.cnbj1.fds.api.mi-img.com/assets-images/zhaoshang/%E4%BC%81%E4%B8%9A%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.docx`
        }
      ],
      brandinfo: [
        {
          name: '品牌代理授权书',
          desc:
            '商标权人出具的授权书（若商标权人为自然人，则需同时提供其亲笔签名的身份证复印件）'
        }
      ],
      categoryinfo: []
    }
  },
  computed: {
    ...mapState({
      categoryCache: state => state.categoryCache
    })
  },
  mounted: function () {
    this.getMenus()
  },
  methods: {
    getMenus: async function () {
      const key = 'category'
      const dataMenus = this.categoryCache.get(key)
      if (!dataMenus) {
        const result = await getCategory()
        const { code, data, msg } = result
        if (!code) {
          this.menus = data.categories
          this.categoryCache.set(key, data.categories)
        } else {
          this.$message.error(msg)
        }
      } else {
        this.menus = this.categoryCache.get(key)
      }
    },
    getCategoryQualification: async function (id) {
      this.categoryinfo = []
      const result = await getCategoryQualification({ categoryIds: id })
      const { code, data, msg } = result
      if (!code) {
        this.categoryinfo = data.qualification
      } else {
        this.$message.error(msg)
      }
    },
    getDetailInfo: function (id) {
      this.getCategoryQualification(id)
    }
  }
}
</script>

<style lang="less">
@menuheight: 37px;
.el-submenu__title {
  line-height: @menuheight;
  height: @menuheight;
}
.el-submenu .el-menu-item {
  line-height: @menuheight;
  height: @menuheight;
}
.rule {
  .el-menu {
    border-right: none;
    background-color: none;
  }
  .el-main {
    border-left: solid 1px #e6e6e6;
  }
}
</style>

<style lang="less" scoped>
.rule {
  min-height: calc(~'100vh - 60px - 139px');
}
.rule-content {
  padding: 20px;
  color: #666666;
  .f12 {
    font-size: 12px;
  }
  .f10 {
    font-size: 10px;
  }
  table {
    width: 100%;
    text-align: left;
    margin-top: 10px;
    border-collapse: collapse;
    tr {
      vertical-align: top;
    }
    th {
      line-height: 34px;
      padding: 0 20px;
      font-size: 12px;
      background: #f2f6fc;
      font-weight: unset;
    }
    td {
      padding: 0 20px;
      line-height: 27px;
      font-size: 10px;
      word-break: break-all;
    }
    .stripe {
      background: #fbfafa;
    }
  }
  .tip {
    color: #999999;
    font-size: 10px;
  }
}
</style>
